// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    OrganizationResult,
    OrganizationResultFromJSON,
    OrganizationResultToJSON,
} from './';

/**
 * 
 * @export
 * @interface OrgSearchResults
 */
export interface OrgSearchResults {
    /**
     * 
     * @type {number}
     * @memberof OrgSearchResults
     */
    count: number;
    /**
     * 
     * @type {Array<OrganizationResult>}
     * @memberof OrgSearchResults
     */
    results: Array<OrganizationResult>;
    /**
     * 
     * @type {any}
     * @memberof OrgSearchResults
     */
    aggregations: any;
}

export function OrgSearchResultsFromJSON(json: any): OrgSearchResults {
    return {
        'count': json['count'],
        'results': (json['results'] as Array<any>).map(OrganizationResultFromJSON),
        'aggregations': (json['aggregations']),
    };
}

export function OrgSearchResultsToJSON(value?: OrgSearchResults): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'count': value.count,
        'results': (value.results as Array<any>).map(OrganizationResultToJSON),
        'aggregations': (value.aggregations),
    };
}


